import { memo, useState } from 'react';
import { Avatar, Button, Typography } from 'antd';
import { HistoryOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import moment from 'moment';

import TagBillDetail from 'components/TagBillDetail';
import TagTransactionType from 'components/TagTransactionType';
import UserStatusIndicator from 'components/UserStatusIndicator';
import DefaultLogo from 'assets/images/logovietgrp.svg';
import LastestBillingModal from '../BillingModal/index';
import OrderHistoryModal from '../OrderHistoryModal';
import MessageBillingDetailModal from '../MessageBillingDetailModal';
import './styles.less';

const ConversationHeader = ({ conversationDetail = {}, latestBill = {}, onBack }) => {
  const [openLatestOrder, setOpenLatestOrder] = useState(false);
  const [openOrderHistory, setOpenOrderHistory] = useState(false);
  const [openBillingDetail, setOpenBillingDetail] = useState(false);
  const user = _get(conversationDetail, 'users[0]', {});

  const userId = _get(user, 'id');
  const updatedAt = _get(conversationDetail, 'updatedAt');
  const avatar = _get(user, 'userDetail.avatar') || DefaultLogo;
  const online = _get(user, 'online', 0);
  const lastSeen = _get(user, 'lastSeen', null);

  const handleCloseLatestBillModal = () => {
    setOpenLatestOrder(false);
  };

  const handleOpenOrderHistory = () => {
    setOpenOrderHistory(true);
  };

  const handleCloseOrderHistory = () => {
    setOpenOrderHistory(false);
  };

  return (
    <div className="conversation-header-container">
      {onBack && (
        <Button
          icon={<ArrowLeftOutlined />}
          onClick={onBack}
          type="text"
          className="back-btn"
        />
      )}
      <div className="flex items-center" style={{ flex: 1, minWidth: 0 }}>
        <Avatar size={48} src={avatar} className="avatar" />
        <div className="conversation-header-content">
          <div className="username">{user.name}</div>
          <UserStatusIndicator online={online} lastSeen={lastSeen} showText size="md" />
        </div>
      </div>

      <Button
        icon={<HistoryOutlined />}
        onClick={handleOpenOrderHistory}
        type="primary"
        style={{ marginRight: !_isEmpty(latestBill) ? 16 : 0, width: 'unset' }}
      >
        Lịch sử đơn hàng
      </Button>

      {!_isEmpty(latestBill) && (
        <div className="latest-order flex items-center">
          <div>
            <Typography.Text type="secondary" underline onClick={() => setOpenLatestOrder(!openLatestOrder)}>
              <strong>Đơn hàng mới nhất:{latestBill.orderId}</strong>{' '}
            </Typography.Text>
            <br />
            <Typography.Text type="secondary">
              <strong>Ngày đặt hàng: {moment(latestBill.createdAt).format('DD/MM/YYYY')}</strong>{' '}
            </Typography.Text>
          </div>
          <TagTransactionType status={latestBill.transactionType} />
          <TagBillDetail status={latestBill.status} />
          <Button size="small" type="primary" style={{ width: 'unset' }} onClick={() => setOpenBillingDetail(true)}>
            Xem chi tiết
          </Button>
        </div>
      )}
      {latestBill && (
        <LastestBillingModal billDetail={latestBill} open={openLatestOrder} onClose={handleCloseLatestBillModal} />
      )}
      {userId && <OrderHistoryModal userId={userId} visible={openOrderHistory} onClose={handleCloseOrderHistory} />}
      {latestBill?._id && (
        <MessageBillingDetailModal
          orderId={latestBill._id}
          visible={openBillingDetail}
          onClose={() => setOpenBillingDetail(false)}
        />
      )}
    </div>
  );
};

ConversationHeader.propTypes = {
  conversationDetail: PropTypes.object.isRequired,
  latestBill: PropTypes.object,
  onBack: PropTypes.func,
};

export default memo(ConversationHeader);
